/* ──────────────────────────────────────────────────────────────
 *  Geometry API — 3-D preview mesh data
 * ────────────────────────────────────────────────────────────── */

import axiosClient from './axiosClient';
import type { BushingType } from '@/types/bushing';
import type { GeometryMesh, GeometryView } from '@/types/geometry';

/** Parameters for requesting tessellated geometry. */
export interface GeometryRequest {
  jobId: string;
  sampleId: string;
  bushingType: BushingType;
  viewType: GeometryView;
  sampleData: Record<string, number>;
  coreMaterial?: string;
  outerMaterial?: string;
  interSleeveMaterial?: string;
  coreId?: number | null;
  minArea?: number | null;
  weightPockets?: boolean;
  sleeveThickness?: number;
}

/** Options for the geometry fetch (allows request cancellation). */
export interface GeometryFetchOptions {
  signal?: AbortSignal;
}

/** Fetch tessellated mesh data for the 3-D preview. */
export async function getGeometry(
  req: GeometryRequest,
  options?: GeometryFetchOptions,
): Promise<GeometryMesh> {
  const { data } = await axiosClient.post<GeometryMesh>(
    '/geometry/mesh',
    req,
    { signal: options?.signal },
  );
  return data;
}
